import { render, staticRenderFns } from "./SuspiciousIpsList.vue?vue&type=template&id=072b3f9e"
import script from "./SuspiciousIpsList.vue?vue&type=script&lang=js"
export * from "./SuspiciousIpsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports